import script from "./InformationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./InformationModal.vue?vue&type=script&setup=true&lang=js"

import "./InformationModal.vue?vue&type=style&index=0&id=21f15756&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21f15756"]])

export default __exports__